import { jsx as _jsx } from "react/jsx-runtime";
import Markdown from "markdown-to-jsx";
export const MarkdownWrapper = ({ children = "", ...rest }) => {
    return _jsx(Markdown, { ...rest, children: children });
};
//# sourceMappingURL=MarkdownWrapper.js.map